// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import {Dialog, IconButton} from '@material-ui/core';
import {Close} from '@material-ui/icons';

import {makeStyles} from '@material-ui/core/styles';

import type {DialogProps} from '@material-ui/core';
type Props = {
  isSaving?: boolean,
  handleCloseModal?: (e?: any) => void,
  // promptOpen?: boolean,
  // handlePromptClose?: () => void,
  children?: React.Node,
} & DialogProps;

const useStyles = makeStyles(theme => ({
  paper: {
    // width: 768,
    maxWidth: 'unset',
    alignItems: 'center',
    padding: theme.spacing(2, 7),
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      maxHeight: 'calc(100% - 32px)',
      width: '100%',
      padding: '.5rem',
      margin: '.25rem',
    },
    boxShadow: 'unset',
    borderRadius: '12px',
    // '&:focus': {
    //   outline: 'none',
    // },
  },
  closeButton: {
    margin: 12,
    zIndex: 1,
    color: 'black',
    backgroundColor: 'white',
    position: 'absolute',
    top: 0,
    right: 0,
  },
  backDrop: {
    background: 'rgba(0, 0, 0, 0.3)',
  },
}));
export default function CustomModal(props: Props) {
  const {
    isSaving,
    // errors,
    handleCloseModal,
    // promptOpen,
    // handlePromptClose,
    children,
    classes: propClasses,
    open,
    ...otherProps
  } = props;

  const classes = useStyles();

  const dialogClasses = {
    ...propClasses,
    paper: `${classes.paper} ${propClasses ? propClasses.paper : ''}`,
    container: classes.container,
  };

  return (
    <Dialog
      classes={dialogClasses}
      onClose={handleCloseModal}
      BackdropProps={{
        classes: {
          root: classes.backDrop,
        },
      }}
      open={Boolean(open)}
      {...otherProps}
    >
      {handleCloseModal && (
        <IconButton
          size="small"
          className={classes.closeButton}
          aria-label="close"
          onClick={handleCloseModal}
          disabled={isSaving}
        >
          <Close />
        </IconButton>
      )}
      {children}
    </Dialog>
  );
}

CustomModal.propTypes = {
  isSaving: PropTypes.bool,
  // errors: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func,
  // promptOpen: PropTypes.bool,
  // handlePromptClose: PropTypes.func,
  children: PropTypes.node,
};
